export { default as PhotographOutlineIcon } from './PhotographOutlineIcon';
